import { MyBoardListItemTypes } from '@typedef/components/Login/login.types';
import { SET_ROOM_ACTION_TYPE } from './modules/actionTypes';

export const setRoomAction = (room: MyBoardListItemTypes[]) => ({
  type: SET_ROOM_ACTION_TYPE,
  payload: room,
});

export type MultiRoomActionTypes = ReturnType<typeof setRoomAction>;
